<script lang="ts" setup>
import type { IAppProps } from '@/interfaces/IAppProps'
import { until } from '@vueuse/core'
import { useHead } from '@vueuse/head'
import { storeToRefs } from 'pinia'
import { useEntryProps } from '@/composable/useDatasetProps'
import { useGlobalStore } from '@/stores/globalStore'
import { useUserStore } from '@/stores/userStore'
import { isInitDepositDoneOldUser } from './isInitDepositDoneOldUser'

const { brandName, isApp } = useEntryProps<IAppProps>()
const userStore = useUserStore()
const globalStore = useGlobalStore()

const gtmScript = (): string => {
    return `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-${globalStore.gtmCode()}');`
}

const gtmDataLayerScript = (): string => {
    const pathSegments = window.location.pathname.split('/')
    const product = pathSegments[2] ? pathSegments[2].replace(/^\w/, c => c.toUpperCase()) : ''

    return `commonDataLayer = window.dataLayer || [];
    commonDataLayer.push({
        currency : '${userStore.gtmCommonData.currency}',
        identify: '${userStore.gtmCommonData.identify}',
        type : '${userStore.gtmCommonData.jurisdiction}',
        brand : '${brandName}',
        uuid : '${userStore.gtmCommonData.trackingId}',
        product : '${product}',
        projectname : 'NM',
        event : 'common',
        DPabtest: '${isInitDepositDoneOldUser(userStore.userInfo) ? 'old' : ''}',
        platform: '${isApp ? 'App' : 'Web'}'
    });`
}

const vwoScript = (): any => {
    return {
        id: 'vwoCode',
        type: 'text/javascript',
        innerHTML: `window._vwo_code || (function() {
var account_id=804155,
version=2.1,
settings_tolerance=2000,
hide_element='body',
hide_element_style = 'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important;transition:none !important;',
/* DO NOT EDIT BELOW THIS LINE */
f=false,w=window,d=document,v=d.querySelector('#vwoCode'),cK='_vwo_'+account_id+'_settings',cc={};try{var c=JSON.parse(localStorage.getItem('_vwo_'+account_id+'_config'));cc=c&&typeof c==='object'?c:{}}catch(e){}var stT=cc.stT==='session'?w.sessionStorage:w.localStorage;code={nonce:v&&v.nonce,use_existing_jquery:function(){return typeof use_existing_jquery!=='undefined'?use_existing_jquery:undefined},library_tolerance:function(){return typeof library_tolerance!=='undefined'?library_tolerance:undefined},hide_element:function(){return typeof hide_element!=='undefined'?hide_element:undefined},hide_element_style:function(){return typeof hide_element_style!=='undefined'?hide_element_style:undefined},finished:function(){if(!f){f=true;var e=d.getElementById('_vwo_'+account_id+'_hide');if(e){e.style.cssText=hide_element_style}}},finish:function(){if(performance.getEntriesByName && performance.getEntriesByName('first-contentful-paint')[0]){performance.getEntriesByName('first-contentful-paint')[0].startTime<settings_tolerance?code.finished():setTimeout(code.finish,100)}else{setTimeout(code.finish,100)}}};if(stT.getItem(cK)===null){stT.setItem(cK,JSON.stringify({version:version,finished:false,fn:code.finish}));code.finish()}else{try{var st=JSON.parse(stT.getItem(cK));if(st.finished===false){st.fn=code.finish;stT.setItem(cK,JSON.stringify(st));code.finish()}}catch(e){stT.setItem(cK,JSON.stringify({version:version,finished:false,fn:code.finish}));code.finish()}}})();`,
    }
};

(async () => {
    await until(storeToRefs(userStore).isUserInfoReady).toBe(true)
    await until(storeToRefs(userStore).isGtmDataReady).toBe(true)
    useHead({
        link: [{ rel: 'preconnect', href: 'https://dev.visualwebsiteoptimizer.com' }],
        script: [{ children: `${gtmScript()}` }, { children: `${gtmDataLayerScript()}` }, vwoScript()],
    })
})()
</script>

<template>
    <div />
</template>
